export default "__VITE_ASSET__BcHMNeKT__"